"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAssistedAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const types_1 = require("../../../security/session/cc/types");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
const biometricValidation_1 = require("./biometricValidation");
class MbAssistedAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, xhr, modelbankUSDManager) {
        super(session);
        this.username = '';
        this.interactionId = '';
        this.agentToken = '';
        this.documentType = 'user';
        /**
         * Know if user has trusted device
         * @param username string
         * @returns Promise<boolean>
         */
        this.userHasTrustedDevice = async (username) => {
            const resp = await this.xhr.POST(`${window.MIDDLEWARE_DEVICES_BASE_HOST}/admin/devices/trusted`, {
                username,
                documentType: this.documentType,
            }, { headers: { accessToken: this.agentToken } });
            return !!resp.data;
        };
        /**
         * Initialize Assisted Login
         * @param username string
         * @param verifyOriginalActions AssistedLoginInitActionsType
         */
        this.init = async (username, verifyOriginalActions) => {
            this.username = username;
            const verifyActions = this.addLoginToActionSuccess(verifyOriginalActions);
            if (!this.biometricValidation) {
                this.biometricValidation = new biometricValidation_1.BiometricValidation({
                    verifyActions,
                    agentToken: this.agentToken,
                    interactionId: this.interactionId,
                    xhr: this.xhr,
                });
            }
            else {
                this.biometricValidation.updateVerifyActions(verifyActions);
            }
            await this.biometricValidation.waitUserAuthorization(username);
        };
        /**
         * Check if the user has validated the challenge
         */
        this.manualVerify = async () => {
            await this.biometricValidation?.manualVerify();
        };
        this.addLoginToActionSuccess = (verifyOriginalActions) => ({
            onSuccess: async (verifyData) => {
                await this.login({
                    accessToken: verifyData.accessToken,
                    expiresIn: verifyData.expiresIn,
                    refreshToken: verifyData.refreshToken,
                    sessionExpiresAt: new Date(verifyData.sessionExpiresAt),
                    agentToken: this.agentToken,
                    username: this.username,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(verifyData.expiresIn),
                    entrypoint: types_1.EntrypointType.AssistedLogin,
                });
                this.modelbankUSDManager
                    .getMethods()
                    .assistedAuthenticateSuccess(verifyData.accessToken, verifyData.refreshToken, verifyData.clientRole);
                verifyOriginalActions.onSuccess({ clientRole: verifyData.clientRole });
            },
            onError: verifyOriginalActions.onError,
        });
        this.doLogin = async (data) => {
            if (!this.agentToken) {
                const { agentToken, interactionId, userName } = await this.modelbankUSDManager.init();
                this.agentToken = agentToken;
                this.interactionId = interactionId;
                return {
                    agentToken,
                    interactionId,
                    username: userName,
                    accessToken: '',
                    refreshToken: '',
                    entrypoint: types_1.EntrypointType.AssistedLogin,
                };
            }
            return data;
        };
        this.doLogout = async () => {
            const accessToken = this.getSession().getData()?.accessToken;
            await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/logout`, { accessToken });
        };
        this.xhr = xhr;
        this.modelbankUSDManager = modelbankUSDManager;
    }
}
exports.MbAssistedAuthenticator = MbAssistedAuthenticator;
//# sourceMappingURL=assisted.js.map